export type TCustomsOrgansOnBorderItem = {
  id: number;
  name: string;
  kod: string;
  parent: number; // -1 означает корень
  children?: TCustomsOrgansOnBorderItem[];
};

export type TAggregatedTradeType = keyof TAggregatedIndicators;

export type TAggregatedIndicators = {
  export: TAggregatedBaseIndicators;
  import: TAggregatedBaseIndicators;
};

export type TAggregatedBaseIndicators = {
  weight: number;
  price: number;
};

export type TAggregatedBaseTradeIndicators<T> = {
  export: T;
  import: T;
};

export enum IndicatorTypes {
  PRICE = 1,
  WEIGHT = 2,
  PRICE_AND_WEIGHT = 3,
}

export enum TradeDirections {
  EXPORT = 1,
  IMPORT = 2,
  EXPORT_AND_IMPORT = 3,
}

export enum CostTypes {
  DOLLARS = 1,
  THOUSANDS_OF_DOLLARS = 2,
  MILLIONS_OF_DOLLARS = 3,
  BILLIONS_OF_DOLLARS = 4,
}

export enum WeightTypes {
  KILOS = 1,
  TONS = 2,
  THOUSANDS_TONS = 3,
  MILLIONS_TONS = 4,
}

export enum ShowSections {
  PRODUCTS = 1,
  COUNTRIES = 2,
}

export enum SelectTypes {
  PERIOD = 1,
  CUMULATIVE_TOTAL = 2,
}

export enum ProductValues {
  ALL_PRODUCTS = '0',
}

export enum TreeRegionRFValues {
  RF = 'RF',
  // Центральный федеральный округ
  FO1 = 'FO1',
  BELGOROD = '14000',
  BRYANSK = '15000',
  VLADIMIR = '17000',
  VORONEZH = '20000',
  IVANOVO = '24000',
  KALUGA = '29000',
  KOSTROMA = '34000',
  KURSK = '38000',
  LIPETSK = '42000',
  MOSCOW_REGION = '46000',
  OREL = '54000',
  RYAZAN = '61000',
  SMOLENSK = '66000',
  TAMBOV = '68000',
  TVER = '28000',
  TULA = '70000',
  YAROSLAVL = '78000',
  MOSCOW = '45000',
  // Северо-Западный федеральный округ
  FO2 = 'FO2',
  KARELIA = '86000',
  KOMI = '87000',
  ARKHANGELSK = '11000',
  VOLOGDA = '19000',
  KALININGRAD = '27000',
  LENINGRAD = '41000',
  MURMANSK = '47000',
  NOVGOROD = '49000',
  PSKOV = '58000',
  SAINT_PETERSBURG = '40000',
  NENETS = '11100',
  // Южный федеральный округ
  FO3 = 'FO3',
  ADYGEA = '79000',
  KALMYKIA = '85000',
  KRASNODAR = '03000',
  ASTRAKHAN = '12000',
  VOLGOGRAD = '18000',
  ROSTOV = '60000',
  // Северо-Кавказский федеральный округ
  FO4 = 'FO4',
  DAGESTAN = '82000',
  INGUSHETIA = '26000',
  KABARDINO_BALKARIA = '83000',
  KARACHAY_CHERKESSIA = '91000',
  NORTH_OSSETIA = '90000',
  CHECHNYA = '96000',
  STAVROPOL = '07000',
  // Приволжский федеральный округ
  FO5 = 'FO5',
  BASHKORTOSTAN = '80000',
  MARI_EL = '88000',
  MORDOVIA = '89000',
  TATARSTAN = '92000',
  UDMURTIA = '94000',
  CHUVASHIA = '97000',
  KIROV = '33000',
  NIZHNY_NOVGOROD = '22000',
  ORENBURG = '53000',
  PENZA = '56000',
  PERM = '57000',
  SAMARA = '36000',
  SARATOV = '63000',
  ULYANOVSK = '73000',
  // Уральский федеральный округ
  FO6 = 'FO6',
  KURGAN = '37000',
  SVERDLOVSK = '65000',
  TYUMEN = '71000',
  CHELYABINSK = '75000',
  KHANTY_MANSIYSK = '71100',
  YAMALO_NENETS = '71140',
  // Сибирский федеральный округ
  FO7 = 'FO7',
  ALTAI_REPUBLIC = '84000',
  BURYATIA = '81000',
  TUVA = '93000',
  KHAKASSIA = '95000',
  ALTAI_KRAI = '01000',
  ZABAYKALSKY = '76000',
  KRASNOYARSK = '04000',
  IRKUTSK = '25000',
  KEMEROVO = '32000',
  NOVOSIBIRSK = '50000',
  OMSK = '52000',
  TOMSK = '69000',
  // Дальневосточный федеральный округ
  FO8 = 'FO8',
  SAKHA = '98000',
  KAMCHATKA = '30000',
  PRIMORSKY = '05000',
  KHABAROVSK = '08000',
  AMUR = '10000',
  MAGADAN = '44000',
  SAKHALIN = '64000',
  JEWISH_AUTONOMOUS = '99000',
  CHUKOTKA = '77000',
  // Крымский федеральный округ
  FO9 = 'FO9',
  CRIMEA = '35000',
  SEVASTOPOL = '67000',
  // Регион не указан
  REGION_NOT_SPECIFIED = '99999',
}

export enum TreeCountryValues {
  // Все страны → По экономическим ареалам → Все страны → Армения
  ECO = 'ECO',
  ALL_COUNTRIES = '99',
  ALL_COUNTRIES_WITHOUT_BELARUS = '98',
  DZ = 'DZ',
  UNK_ECO = 'UNK_ECO',
  // По Географическим Ареалам
  GEO = 'GEO',
  UNK_GEO = 'UNK_GEO',
  // Значения с префиксами ареалов (формат: {код_страны}_{код_ареала})
  // Ареал "99" - Все Страны
  AFGHANISTAN_99 = '004_99',
  ALBANIA_99 = '008_99',
  ANTARCTICA_99 = '010_99',
  ALGERIA_99 = '012_99',
  AMERICAN_SAMOA_99 = '016_99',
  ANDORRA_99 = '020_99',
  ANGOLA_99 = '024_99',
  ANTIGUA_AND_BARBUDA_99 = '028_99',
  AZERBAIJAN_99 = '031_99',
  ARGENTINA_99 = '032_99',
  AUSTRALIA_99 = '036_99',
  AUSTRIA_99 = '040_99',
  BAHAMAS_99 = '044_99',
  BAHRAIN_99 = '048_99',
  BANGLADESH_99 = '050_99',
  ARMENIA_99 = '051_99',
  BARBADOS_99 = '052_99',
  BELGIUM_99 = '056_99',
  BERMUDA_99 = '060_99',
  BHUTAN_99 = '064_99',
  BOLIVIA_99 = '068_99',
  BOSNIA_AND_HERZEGOVINA_99 = '070_99',
  BOTSWANA_99 = '072_99',
  BOUVET_ISLAND_99 = '074_99',
  BRAZIL_99 = '076_99',
  BELIZE_99 = '084_99',
  BRITISH_INDIAN_OCEAN_TERRITORY_99 = '086_99',
  SOLOMON_ISLANDS_99 = '090_99',
  BRITISH_VIRGIN_ISLANDS_99 = '092_99',
  BRUNEI_99 = '096_99',
  BULGARIA_99 = '100_99',
  MYANMAR_99 = '104_99',
  BURUNDI_99 = '108_99',
  BELARUS_99 = '112_99',
  CAMBODIA_99 = '116_99',
  CAMEROON_99 = '120_99',
  CANADA_99 = '124_99',
  CAPE_VERDE_99 = '132_99',
  CAYMAN_ISLANDS_99 = '136_99',
  CENTRAL_AFRICAN_REPUBLIC_99 = '140_99',
  SRI_LANKA_99 = '144_99',
  CHAD_99 = '148_99',
  CHILE_99 = '152_99',
  CHINA_99 = '156_99',
  TAIWAN_99 = '158_99',
  CHRISTMAS_ISLAND_99 = '162_99',
  COCOS_ISLANDS_99 = '166_99',
  COLOMBIA_99 = '170_99',
  COMOROS_99 = '174_99',
  MAYOTTE_99 = '175_99',
  CONGO_99 = '178_99',
  CONGO_DR_99 = '180_99',
  COOK_ISLANDS_99 = '184_99',
  COSTA_RICA_99 = '188_99',
  CROATIA_99 = '191_99',
  CUBA_99 = '192_99',
  CYPRUS_99 = '196_99',
  CZECHIA_99 = '203_99',
  BENIN_99 = '204_99',
  DENMARK_99 = '208_99',
  DOMINICA_99 = '212_99',
  DOMINICAN_REPUBLIC_99 = '214_99',
  ECUADOR_99 = '218_99',
  EL_SALVADOR_99 = '222_99',
  EQUATORIAL_GUINEA_99 = '226_99',
  ETHIOPIA_99 = '231_99',
  ERITREA_99 = '232_99',
  ESTONIA_99 = '233_99',
  FAROE_ISLANDS_99 = '234_99',
  FALKLAND_ISLANDS_99 = '238_99',
  SOUTH_GEORGIA_AND_SOUTH_SANDWICH_ISLANDS_99 = '239_99',
  FIJI_99 = '242_99',
  FINLAND_99 = '246_99',
  ALAND_ISLANDS_99 = '248_99',
  FRANCE_99 = '250_99',
  FRENCH_GUIANA_99 = '254_99',
  FRENCH_POLYNESIA_99 = '258_99',
  FRENCH_SOUTHERN_TERRITORIES_99 = '260_99',
  DJIBOUTI_99 = '262_99',
  GABON_99 = '266_99',
  GEORGIA_99 = '268_99',
  GAMBIA_99 = '270_99',
  PALESTINE_99 = '275_99',
  GERMANY_99 = '276_99',
  GHANA_99 = '288_99',
  GIBRALTAR_99 = '292_99',
  KIRIBATI_99 = '296_99',
  GREECE_99 = '300_99',
  GREENLAND_99 = '304_99',
  GRENADA_99 = '308_99',
  GUADELOUPE_99 = '312_99',
  GUAM_99 = '316_99',
  GUATEMALA_99 = '320_99',
  GUINEA_99 = '324_99',
  GUYANA_99 = '328_99',
  HAITI_99 = '332_99',
  HEARD_ISLAND_AND_MCDONALD_ISLANDS_99 = '334_99',
  VATICAN_99 = '336_99',
  HONDURAS_99 = '340_99',
  HONG_KONG_99 = '344_99',
  HUNGARY_99 = '348_99',
  ICELAND_99 = '352_99',
  INDIA_99 = '356_99',
  INDONESIA_99 = '360_99',
  IRAN_99 = '364_99',
  IRAQ_99 = '368_99',
  IRELAND_99 = '372_99',
  ISRAEL_99 = '376_99',
  ITALY_99 = '380_99',
  IVORY_COAST_99 = '384_99',
  JAMAICA_99 = '388_99',
  JAPAN_99 = '392_99',
  KAZAKHSTAN_99 = '398_99',
  JORDAN_99 = '400_99',
  KENYA_99 = '404_99',
  NORTH_KOREA_99 = '408_99',
  SOUTH_KOREA_99 = '410_99',
  KUWAIT_99 = '414_99',
  KYRGYZSTAN_99 = '417_99',
  LAOS_99 = '418_99',
  LEBANON_99 = '422_99',
  LESOTHO_99 = '426_99',
  LATVIA_99 = '428_99',
  LIBERIA_99 = '430_99',
  LIBYA_99 = '434_99',
  LIECHTENSTEIN_99 = '438_99',
  LITHUANIA_99 = '440_99',
  LUXEMBOURG_99 = '442_99',
  MACAO_99 = '446_99',
  MADAGASCAR_99 = '450_99',
  MALAWI_99 = '454_99',
  MALAYSIA_99 = '458_99',
  MALDIVES_99 = '462_99',
  MALI_99 = '466_99',
  MALTA_99 = '470_99',
  MARTINIQUE_99 = '474_99',
  MAURITANIA_99 = '478_99',
  MAURITIUS_99 = '480_99',
  MEXICO_99 = '484_99',
  MONACO_99 = '492_99',
  MONGOLIA_99 = '496_99',
  MOLDOVA_99 = '498_99',
  MONTENEGRO_99 = '499_99',
  MONTSERRAT_99 = '500_99',
  MOROCCO_99 = '504_99',
  MOZAMBIQUE_99 = '508_99',
  OMAN_99 = '512_99',
  NAMIBIA_99 = '516_99',
  NAURU_99 = '520_99',
  NEPAL_99 = '524_99',
  NETHERLANDS_99 = '528_99',
  NETHERLANDS_ANTILLES_99 = '530_99',
  CURACAO_99 = '531_99',
  ARUBA_99 = '533_99',
  SINT_MAARTEN_99 = '534_99',
  BONAIRE_SINT_EUSTATIUS_AND_SABA_99 = '535_99',
  NEW_CALEDONIA_99 = '540_99',
  VANUATU_99 = '548_99',
  NEW_ZEALAND_99 = '554_99',
  NICARAGUA_99 = '558_99',
  NIGER_99 = '562_99',
  NIGERIA_99 = '566_99',
  NIUE_99 = '570_99',
  NORFOLK_ISLAND_99 = '574_99',
  NORWAY_99 = '578_99',
  NORTHERN_MARIANA_ISLANDS_99 = '580_99',
  US_MINOR_OUTLYING_ISLANDS_99 = '581_99',
  MICRONESIA_99 = '583_99',
  MARSHALL_ISLANDS_99 = '584_99',
  PALAU_99 = '585_99',
  PAKISTAN_99 = '586_99',
  PANAMA_99 = '591_99',
  PAPUA_NEW_GUINEA_99 = '598_99',
  PARAGUAY_99 = '600_99',
  PERU_99 = '604_99',
  PHILIPPINES_99 = '608_99',
  PITCAIRN_99 = '612_99',
  POLAND_99 = '616_99',
  PORTUGAL_99 = '620_99',
  GUINEA_BISSAU_99 = '624_99',
  TIMOR_LESTE_99 = '626_99',
  PUERTO_RICO_99 = '630_99',
  QATAR_99 = '634_99',
  REUNION_99 = '638_99',
  ROMANIA_99 = '642_99',
  RUSSIA_99 = '643_99',
  RWANDA_99 = '646_99',
  SAINT_BARTHELEMY_99 = '652_99',
  SAINT_HELENA_99 = '654_99',
  SAINT_KITTS_AND_NEVIS_99 = '659_99',
  ANGUILLA_99 = '660_99',
  SAINT_LUCIA_99 = '662_99',
  SAINT_MARTIN_99 = '663_99',
  SAINT_PIERRE_AND_MIQUELON_99 = '666_99',
  SAINT_VINCENT_AND_GRENADINES_99 = '670_99',
  SAN_MARINO_99 = '674_99',
  SAO_TOME_AND_PRINCIPE_99 = '678_99',
  SAUDI_ARABIA_99 = '682_99',
  SENEGAL_99 = '686_99',
  SERBIA_99 = '688_99',
  SEYCHELLES_99 = '690_99',
  SIERRA_LEONE_99 = '694_99',
  SINGAPORE_99 = '702_99',
  SLOVAKIA_99 = '703_99',
  VIETNAM_99 = '704_99',
  SLOVENIA_99 = '705_99',
  SOMALIA_99 = '706_99',
  SOUTH_AFRICA_99 = '710_99',
  ZIMBABWE_99 = '716_99',
  SPAIN_99 = '724_99',
  SOUTH_SUDAN_99 = '728_99',
  SUDAN_728_99 = '729_99',
  WESTERN_SAHARA_99 = '732_99',
  SUDAN_736_99 = '736_99',
  SURINAME_99 = '740_99',
  SVALBARD_AND_JAN_MAYEN_99 = '744_99',
  ESWATINI_99 = '748_99',
  SWEDEN_99 = '752_99',
  SWITZERLAND_99 = '756_99',
  SYRIA_99 = '760_99',
  TAJIKISTAN_99 = '762_99',
  THAILAND_99 = '764_99',
  TOGO_99 = '768_99',
  TOKELAU_99 = '772_99',
  TONGA_99 = '776_99',
  TRINIDAD_AND_TOBAGO_99 = '780_99',
  UAE_99 = '784_99',
  TUNISIA_99 = '788_99',
  TURKEY_99 = '792_99',
  TURKMENISTAN_99 = '795_99',
  TURKS_AND_CAICOS_ISLANDS_99 = '796_99',
  TUVALU_99 = '798_99',
  UGANDA_99 = '800_99',
  UKRAINE_99 = '804_99',
  NORTH_MACEDONIA_99 = '807_99',
  EGYPT_99 = '818_99',
  UNITED_KINGDOM_99 = '826_99',
  CHANNEL_ISLANDS_99 = '830_99',
  GUERNSEY_99 = '831_99',
  JERSEY_99 = '832_99',
  ISLE_OF_MAN_99 = '833_99',
  TANZANIA_99 = '834_99',
  UNITED_STATES_99 = '840_99',
  US_VIRGIN_ISLANDS_99 = '850_99',
  BURKINA_FASO_99 = '854_99',
  URUGUAY_99 = '858_99',
  UZBEKISTAN_99 = '860_99',
  VENEZUELA_99 = '862_99',
  WALLIS_AND_FUTUNA_99 = '876_99',
  SAMOA_99 = '882_99',
  YEMEN_99 = '887_99',
  SERBIA_AND_MONTENEGRO_99 = '891_99',
  ZAMBIA_99 = '894_99',
  ABKHAZIA_99 = '895_99',
  SOUTH_OSETIA_99 = '896_99',
  DNR_99 = '897_99',
  LNR_99 = '898_99',
  COUNTRY_UNKNOWN_99 = '000_99',
  // Ареал "98" - Все Страны Без Беларусии
  AFGHANISTAN_98 = '004_98',
  ALBANIA_98 = '008_98',
  ANTARCTICA_98 = '010_98',
  ALGERIA_98 = '012_98',
  AMERICAN_SAMOA_98 = '016_98',
  ANDORRA_98 = '020_98',
  ANGOLA_98 = '024_98',
  ANTIGUA_AND_BARBUDA_98 = '028_98',
  AZERBAIJAN_98 = '031_98',
  ARGENTINA_98 = '032_98',
  AUSTRALIA_98 = '036_98',
  AUSTRIA_98 = '040_98',
  BAHAMAS_98 = '044_98',
  BAHRAIN_98 = '048_98',
  BANGLADESH_98 = '050_98',
  ARMENIA_98 = '051_98',
  BARBADOS_98 = '052_98',
  BELGIUM_98 = '056_98',
  BERMUDA_98 = '060_98',
  BHUTAN_98 = '064_98',
  BOLIVIA_98 = '068_98',
  BOSNIA_AND_HERZEGOVINA_98 = '070_98',
  BOTSWANA_98 = '072_98',
  BOUVET_ISLAND_98 = '074_98',
  BRAZIL_98 = '076_98',
  BELIZE_98 = '084_98',
  BRITISH_INDIAN_OCEAN_TERRITORY_98 = '086_98',
  SOLOMON_ISLANDS_98 = '090_98',
  BRITISH_VIRGIN_ISLANDS_98 = '092_98',
  BRUNEI_98 = '096_98',
  BULGARIA_98 = '100_98',
  MYANMAR_98 = '104_98',
  BURUNDI_98 = '108_98',
  CAMBODIA_98 = '116_98',
  CAMEROON_98 = '120_98',
  CANADA_98 = '124_98',
  CAPE_VERDE_98 = '132_98',
  CAYMAN_ISLANDS_98 = '136_98',
  CENTRAL_AFRICAN_REPUBLIC_98 = '140_98',
  SRI_LANKA_98 = '144_98',
  CHAD_98 = '148_98',
  CHILE_98 = '152_98',
  CHINA_98 = '156_98',
  TAIWAN_98 = '158_98',
  CHRISTMAS_ISLAND_98 = '162_98',
  COCOS_ISLANDS_98 = '166_98',
  COLOMBIA_98 = '170_98',
  COMOROS_98 = '174_98',
  MAYOTTE_98 = '175_98',
  CONGO_98 = '178_98',
  CONGO_DR_98 = '180_98',
  COOK_ISLANDS_98 = '184_98',
  COSTA_RICA_98 = '188_98',
  CROATIA_98 = '191_98',
  CUBA_98 = '192_98',
  CYPRUS_98 = '196_98',
  CZECHIA_98 = '203_98',
  BENIN_98 = '204_98',
  DENMARK_98 = '208_98',
  DOMINICA_98 = '212_98',
  DOMINICAN_REPUBLIC_98 = '214_98',
  ECUADOR_98 = '218_98',
  EL_SALVADOR_98 = '222_98',
  EQUATORIAL_GUINEA_98 = '226_98',
  ETHIOPIA_98 = '231_98',
  ERITREA_98 = '232_98',
  ESTONIA_98 = '233_98',
  FAROE_ISLANDS_98 = '234_98',
  FALKLAND_ISLANDS_98 = '238_98',
  SOUTH_GEORGIA_AND_SOUTH_SANDWICH_ISLANDS_98 = '239_98',
  FIJI_98 = '242_98',
  FINLAND_98 = '246_98',
  ALAND_ISLANDS_98 = '248_98',
  FRANCE_98 = '250_98',
  FRENCH_GUIANA_98 = '254_98',
  FRENCH_POLYNESIA_98 = '258_98',
  FRENCH_SOUTHERN_TERRITORIES_98 = '260_98',
  DJIBOUTI_98 = '262_98',
  GABON_98 = '266_98',
  GEORGIA_98 = '268_98',
  GAMBIA_98 = '270_98',
  PALESTINE_98 = '275_98',
  GERMANY_98 = '276_98',
  GHANA_98 = '288_98',
  GIBRALTAR_98 = '292_98',
  KIRIBATI_98 = '296_98',
  GREECE_98 = '300_98',
  GREENLAND_98 = '304_98',
  GRENADA_98 = '308_98',
  GUADELOUPE_98 = '312_98',
  GUAM_98 = '316_98',
  GUATEMALA_98 = '320_98',
  GUINEA_98 = '324_98',
  GUYANA_98 = '328_98',
  HAITI_98 = '332_98',
  HEARD_ISLAND_AND_MCDONALD_ISLANDS_98 = '334_98',
  VATICAN_98 = '336_98',
  HONDURAS_98 = '340_98',
  HONG_KONG_98 = '344_98',
  HUNGARY_98 = '348_98',
  ICELAND_98 = '352_98',
  INDIA_98 = '356_98',
  INDONESIA_98 = '360_98',
  IRAN_98 = '364_98',
  IRAQ_98 = '368_98',
  IRELAND_98 = '372_98',
  ISRAEL_98 = '376_98',
  ITALY_98 = '380_98',
  IVORY_COAST_98 = '384_98',
  JAMAICA_98 = '388_98',
  JAPAN_98 = '392_98',
  KAZAKHSTAN_98 = '398_98',
  JORDAN_98 = '400_98',
  KENYA_98 = '404_98',
  NORTH_KOREA_98 = '408_98',
  SOUTH_KOREA_98 = '410_98',
  KUWAIT_98 = '414_98',
  KYRGYZSTAN_98 = '417_98',
  LAOS_98 = '418_98',
  LEBANON_98 = '422_98',
  LESOTHO_98 = '426_98',
  LATVIA_98 = '428_98',
  LIBERIA_98 = '430_98',
  LIBYA_98 = '434_98',
  LIECHTENSTEIN_98 = '438_98',
  LITHUANIA_98 = '440_98',
  LUXEMBOURG_98 = '442_98',
  MACAO_98 = '446_98',
  MADAGASCAR_98 = '450_98',
  MALAWI_98 = '454_98',
  MALAYSIA_98 = '458_98',
  MALDIVES_98 = '462_98',
  MALI_98 = '466_98',
  MALTA_98 = '470_98',
  MARTINIQUE_98 = '474_98',
  MAURITANIA_98 = '478_98',
  MAURITIUS_98 = '480_98',
  MEXICO_98 = '484_98',
  MONACO_98 = '492_98',
  MONGOLIA_98 = '496_98',
  MOLDOVA_98 = '498_98',
  MONTENEGRO_98 = '499_98',
  MONTSERRAT_98 = '500_98',
  MOROCCO_98 = '504_98',
  MOZAMBIQUE_98 = '508_98',
  OMAN_98 = '512_98',
  NAMIBIA_98 = '516_98',
  NAURU_98 = '520_98',
  NEPAL_98 = '524_98',
  NETHERLANDS_98 = '528_98',
  NETHERLANDS_ANTILLES_98 = '530_98',
  CURACAO_98 = '531_98',
  ARUBA_98 = '533_98',
  SINT_MAARTEN_98 = '534_98',
  BONAIRE_SINT_EUSTATIUS_AND_SABA_98 = '535_98',
  NEW_CALEDONIA_98 = '540_98',
  VANUATU_98 = '548_98',
  NEW_ZEALAND_98 = '554_98',
  NICARAGUA_98 = '558_98',
  NIGER_98 = '562_98',
  NIGERIA_98 = '566_98',
  NIUE_98 = '570_98',
  NORFOLK_ISLAND_98 = '574_98',
  NORWAY_98 = '578_98',
  NORTHERN_MARIANA_ISLANDS_98 = '580_98',
  US_MINOR_OUTLYING_ISLANDS_98 = '581_98',
  MICRONESIA_98 = '583_98',
  MARSHALL_ISLANDS_98 = '584_98',
  PALAU_98 = '585_98',
  PAKISTAN_98 = '586_98',
  PANAMA_98 = '591_98',
  PAPUA_NEW_GUINEA_98 = '598_98',
  PARAGUAY_98 = '600_98',
  PERU_98 = '604_98',
  PHILIPPINES_98 = '608_98',
  PITCAIRN_98 = '612_98',
  POLAND_98 = '616_98',
  PORTUGAL_98 = '620_98',
  GUINEA_BISSAU_98 = '624_98',
  TIMOR_LESTE_98 = '626_98',
  PUERTO_RICO_98 = '630_98',
  QATAR_98 = '634_98',
  REUNION_98 = '638_98',
  ROMANIA_98 = '642_98',
  RUSSIA_98 = '643_98',
  RWANDA_98 = '646_98',
  SAINT_BARTHELEMY_98 = '652_98',
  SAINT_HELENA_98 = '654_98',
  SAINT_KITTS_AND_NEVIS_98 = '659_98',
  ANGUILLA_98 = '660_98',
  SAINT_LUCIA_98 = '662_98',
  SAINT_MARTIN_98 = '663_98',
  SAINT_PIERRE_AND_MIQUELON_98 = '666_98',
  SAINT_VINCENT_AND_GRENADINES_98 = '670_98',
  SAN_MARINO_98 = '674_98',
  SAO_TOME_AND_PRINCIPE_98 = '678_98',
  SAUDI_ARABIA_98 = '682_98',
  SENEGAL_98 = '686_98',
  SERBIA_98 = '688_98',
  SEYCHELLES_98 = '690_98',
  SIERRA_LEONE_98 = '694_98',
  SINGAPORE_98 = '702_98',
  SLOVAKIA_98 = '703_98',
  VIETNAM_98 = '704_98',
  SLOVENIA_98 = '705_98',
  SOMALIA_98 = '706_98',
  SOUTH_AFRICA_98 = '710_98',
  ZIMBABWE_98 = '716_98',
  SPAIN_98 = '724_98',
  SOUTH_SUDAN_98 = '728_98',
  SUDAN_728_98 = '729_98',
  WESTERN_SAHARA_98 = '732_98',
  SUDAN_736_98 = '736_98',
  SURINAME_98 = '740_98',
  SVALBARD_AND_JAN_MAYEN_98 = '744_98',
  ESWATINI_98 = '748_98',
  SWEDEN_98 = '752_98',
  SWITZERLAND_98 = '756_98',
  SYRIA_98 = '760_98',
  TAJIKISTAN_98 = '762_98',
  THAILAND_98 = '764_98',
  TOGO_98 = '768_98',
  TOKELAU_98 = '772_98',
  TONGA_98 = '776_98',
  TRINIDAD_AND_TOBAGO_98 = '780_98',
  UAE_98 = '784_98',
  TUNISIA_98 = '788_98',
  TURKEY_98 = '792_98',
  TURKMENISTAN_98 = '795_98',
  TURKS_AND_CAICOS_ISLANDS_98 = '796_98',
  TUVALU_98 = '798_98',
  UGANDA_98 = '800_98',
  UKRAINE_98 = '804_98',
  NORTH_MACEDONIA_98 = '807_98',
  EGYPT_98 = '818_98',
  UNITED_KINGDOM_98 = '826_98',
  CHANNEL_ISLANDS_98 = '830_98',
  GUERNSEY_98 = '831_98',
  JERSEY_98 = '832_98',
  ISLE_OF_MAN_98 = '833_98',
  TANZANIA_98 = '834_98',
  UNITED_STATES_98 = '840_98',
  US_VIRGIN_ISLANDS_98 = '850_98',
  BURKINA_FASO_98 = '854_98',
  URUGUAY_98 = '858_98',
  UZBEKISTAN_98 = '860_98',
  VENEZUELA_98 = '862_98',
  WALLIS_AND_FUTUNA_98 = '876_98',
  SAMOA_98 = '882_98',
  YEMEN_98 = '887_98',
  SERBIA_AND_MONTENEGRO_98 = '891_98',
  ZAMBIA_98 = '894_98',
  ABKHAZIA_98 = '895_98',
  SOUTH_OSETIA_98 = '896_98',
  DNR_98 = '897_98',
  LNR_98 = '898_98',
  COUNTRY_UNKNOWN_98 = '000_98',
  EU_98 = 'EU_98',
  // Ареал "DZ" - Дз
  EU_DZ = 'EU_DZ',
  COUNTRY_UNKNOWN_DZ = '000_DZ',
  // Ареал "UNK_ECO" - Страна Неизвестна (Экономические Ареалы)
  COUNTRY_UNKNOWN_UNK_ECO = '000_UNK_ECO',
  // Ареал "UNK_GEO" - Страна Неизвестна (Географические Ареалы)
  COUNTRY_UNKNOWN_UNK_GEO = '000_UNK_GEO',
}
